import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { storeToRefs } from 'pinia';
import { useSlides } from '../../state';
import { useSlideStore } from '../../store';

import { computed, unref } from 'vue';
import { useRoute } from 'vue-router';
export default {
  __name: 'SlideBar',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    _useCssVars(_ctx => ({
      "2f9c759f": _unref(slideWidth),
      "c2c1cd72": _unref(padding)
    }));
    const useStore = useSlideStore();
    const {
      isDisabled,
      isExpand
    } = storeToRefs(useStore);

    // 侧边栏宽度-分为折叠版和默认版
    const slideWidth = computed(() => unref(isExpand) ? `${useSlides.width}px` : `${useSlides.closeWidth}px`);
    // 侧边栏内边距-分为折叠版和默认版
    const padding = computed(() => unref(isExpand) ? `${useSlides.padding}px` : `${useSlides.closePadding}px`);
    // 侧边导航栏菜单列表
    const menuList = computed(() => useSlides.menuList);
    const route = useRoute();
    const changeExpand = () => {
      useStore.changeExpand(!unref(isExpand));
    };
    const __returned__ = {
      useStore,
      isDisabled,
      isExpand,
      slideWidth,
      padding,
      menuList,
      route,
      changeExpand,
      get storeToRefs() {
        return storeToRefs;
      },
      get useSlides() {
        return useSlides;
      },
      get useSlideStore() {
        return useSlideStore;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};